const GET_DATA_MICROSITE = 'micrositio/GET_DATA_MICROSITE';
const GET_DATA_MICROSITE_COMPLETED = 'micrositio/GET_DATA_MICROSITE_COMPLETED';
const GET_DATA_MICROSITE_FAILED = 'micrositio/GET_DATA_MICROSITE_FAILED';

const POST_DATA_MICROSITE = 'micrositio/POST_DATA_MICROSITE';
const POST_DATA_MICROSITE_COMPLETED = 'micrositio/POST_DATA_MICROSITE_COMPLETED';
const POST_DATA_MICROSITE_FAILED = 'micrositio/POST_DATA_MICROSITE_FAILED';
const PUT_DATA_MICROSITE = 'micrositio/PUT_DATA_MICROSITE';
const PUT_DATA_MICROSITE_COMPLETED = 'micrositio/PUT_DATA_MICROSITE_COMPLETED';
const PUT_DATA_MICROSITE_FAILED = 'micrositio/PUT_DATA_MICROSITE_FAILED';

const DELETE_IMAGE_COVER_PHOTO = 'micrositio/DELETE_IMAGE_COVER_PHOTO';
const DELETE_IMAGE_COVER_PHOTO_COMPLETED = 'micrositio/DELETE_IMAGE_COVER_PHOTO_COMPLETED';
const DELETE_IMAGE_COVER_PHOTO_FAILED = 'micrositio/DELETE_IMAGE_COVER_PHOTO_FAILED';

const GET_LIST_PHONE_MICROSITE = 'micrositio/GET_LIST_PHONE_MICROSITE';
const GET_LIST_PHONE_MICROSITE_COMPLETED = 'micrositio/GET_LIST_PHONE_MICROSITE_COMPLETED';
const GET_LIST_PHONE_MICROSITE_FAILED = 'micrositio/GET_LIST_PHONE_MICROSITE_FAILED';

export {
  GET_DATA_MICROSITE,
  GET_DATA_MICROSITE_COMPLETED,
  GET_DATA_MICROSITE_FAILED,
  POST_DATA_MICROSITE,
  POST_DATA_MICROSITE_COMPLETED,
  POST_DATA_MICROSITE_FAILED,
  PUT_DATA_MICROSITE,
  DELETE_IMAGE_COVER_PHOTO,
  DELETE_IMAGE_COVER_PHOTO_COMPLETED,
  DELETE_IMAGE_COVER_PHOTO_FAILED,
  PUT_DATA_MICROSITE_COMPLETED,
  PUT_DATA_MICROSITE_FAILED,
  GET_LIST_PHONE_MICROSITE,
  GET_LIST_PHONE_MICROSITE_COMPLETED,
  GET_LIST_PHONE_MICROSITE_FAILED
};
